// extracted by mini-css-extract-plugin
module.exports = {"list":"Details_list__2vVn5","item":"Details_item__d8XKD","itemTitle":"Details_itemTitle__2kmDz","itemValue":"Details_itemValue__1DlsR"};